import { CustomerNote } from "../customer_note/CustomerNote"
import { ServiceFieldValueDetails } from "../service/ServiceFieldValueDetails"

export class CustomerQuoteServiceDetails {
  description: string
  name: string
  notes: CustomerNote[]
  price: number
  serviceFieldValues: ServiceFieldValueDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(descrition: string, name: string, notesJson: any, price: number, serviceFieldValuesJson: any) {
    this.description = descrition
    this.name = name
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new CustomerNote(n.content)) : []
    this.price = price
    this.serviceFieldValues = serviceFieldValuesJson as ServiceFieldValueDetails[]
  }
}